"use strict";
import { useCallback, useContext } from "react";
import { ShellContext } from "../context";
import { useOwnerModule } from "./useOwnerModule";
export function useModulePathResolver() {
  let { moduleRootPath } = useContext(ShellContext);
  const ownerModule = useOwnerModule();
  return useCallback(
    (...args) => {
      let module;
      let path;
      if (args.length === 2) {
        module = args[0];
        path = args[1];
      } else {
        module = ownerModule;
        path = args[0];
      }
      let finalPath = path;
      if (!path.startsWith("/")) finalPath = `/${finalPath}`;
      if (finalPath === "/") finalPath = "";
      if (moduleRootPath === "/") moduleRootPath = "";
      return module ? `${moduleRootPath}/${module.id}${finalPath}` : finalPath;
    },
    [moduleRootPath]
  );
}
